<script setup lang="ts">
type Emits = {
  (e: "close"): void;
};

defineEmits<Emits>();

const localePath = useLocalePath();
const { bidBlocked, bidVerified, formattedBidLimitAmount } = useBidder();
</script>

<template>
  <BaseModal
    class="bid-limit-warning-wrapper"
    data-cy="bid-limit-warning"
    size="md"
    @close="$emit('close')"
  >
    <h2 class="text-xl md:text-2xl font-semibold">
      {{
        bidBlocked
          ? $t("product.bidLimitWarning.blockedHeader")
          : bidVerified
            ? $t("product.bidLimitWarning.header")
            : $t("product.bidLimitWarning.unverifiedHeader")
      }}
    </h2>
    <div
      v-if="!bidVerified"
      class="text-sm md:text-base pt-2 pb-4"
    >
      {{ $t("product.bidLimitWarning.unverifiedBody") }}
    </div>
    <div
      v-if="bidBlocked"
      class="text-sm md:text-base pt-2 pb-4"
    >
      {{ $t("product.bidLimitWarning.blockedBody") }}
    </div>
    <I18nT
      v-else
      scope="global"
      :keypath="
        formattedBidLimitAmount
          ? 'product.bidLimitWarning.bodyWithBidLimit'
          : 'product.bidLimitWarning.bodyWithoutBidLimit'
      "
      tag="div"
      class="text-sm md:text-base pt-2 pb-4"
    >
      <template #amount>{{ formattedBidLimitAmount }}</template>
    </I18nT>
    <NuxtLink
      id="bid-limit-warning-my-account-button"
      tag="button"
      aria-label="go to my account"
      class="base-button uppercase interaction-dark text-sm md:text-base text-center"
      :to="
        bidBlocked
          ? localePath({ path: '/my-account/my-orders' })
          : localePath({ path: '/my-account' })
      "
      data-cy="bid-limit-warning-button"
    >
      {{
        bidBlocked
          ? $t(`product.bidLimitWarning.myOrders`)
          : $t(`product.bidLimitWarning.myAccount`)
      }}
    </NuxtLink>
    <BaseButton
      id="bid-limit-warning-close-button"
      color-scheme="secondary"
      data-cy="bid-limit-warning-close"
      class="bid-limit-warning-wrapper__button"
      @click="$emit('close')"
    >
      {{ $t(`product.bidLimitWarning.close`) }}
    </BaseButton>
  </BaseModal>
</template>
